export const invoiceList = {
  head: {
    title: "Fatturazione",
    subtitle: "Fatture emesse ai tuoi ospiti",
  },
  stats: {
    filterAria: "Filtra le fatture per stato",
    total: "Totale",
    draft: "Bozze",
    sent: "Emesse",
    processing: "In elaborazione",
    error: "Con errori",
    pending: "In sospeso",
    voided: "Annullate",
  },
  toolbar: {
    searchLabel: "Cerca fatture",
    searchPlaceholder: "N. fattura, cliente, email, codice fiscale o prenotazione…",
    clearSearch: "Cancella ricerca",
    propertyLabel: "Alloggio",
    allProperties: "Tutti gli alloggi",
    typeToSearchProperties: "Digita per cercare gli alloggi.",
    noProperties: "Nessun alloggio trovato.",
    statusLabel: "Stato",
    emisorLabel: "Emittente",
    allEmisores: "Tutti gli emittenti",
    servicesTitle: "Catalogo di addebiti e servizi riutilizzabili",
    services: "Addebiti e servizi",
    createInvoice: "Crea fattura",
  },
  exportZip: {
    button: "ZIP",
    title: "Un file per fattura, ognuna con la sua data e il codice di prenotazione, tutte in un unico ZIP",
    generating: "Generazione…",
    zipping: "Compressione…",
    noPdfInPeriod: "Nel periodo non ci sono fatture emesse con PDF.",
    noPdfInPage: "In questa pagina non ci sono fatture emesse con PDF.",
    tooMany: "La selezione contiene {total} fatture e lo ZIP ne ammette {limit}. Restringi il periodo o i filtri.",
    noneDownloaded: "Non è stato possibile scaricare nessuna fattura da Invopop. Riprova tra qualche minuto.",
    failed: "Non è stato possibile scaricare da Invopop {n} fattura/e: {codes}.",
    withoutPdf: "{n} fattura/e non hanno ancora il PDF su Invopop e non sono nello ZIP: {codes}.",
    restIncluded: "Tutte le altre sono nello ZIP.",
    error: "Non è stato possibile generare lo ZIP delle fatture.",
  },
  linkedClient: {
    prefix: "Fatture collegate a",
    fallbackName: "questo cliente di fatturazione",
    clear: "Rimuovi il filtro cliente",
  },
  table: {
    numberHeader: "N. FATTURA",
    customerHeader: "CLIENTE",
    propertyHeader: "ALLOGGIO",
    totalHeader: "TOTALE",
    statusHeader: "STATO",
    dateHeader: "DATA",
    actionsHeader: "AZIONI",
    draftReferenceTitle: "Riferimento bozza. Il numero fiscale viene assegnato al momento dell'emissione.",
    openReserva: "Apri la prenotazione",
    viewCreditNote: "Visualizza la fattura rettificativa {code}",
    creditNote: "Fattura rettificativa",
    viewError: "Visualizza l'errore",
    voids: "Annulla",
    correctionOf: "Corr. di",
    correctedBy: "Corretta da:",
  },
  sortFields: {
    number: "numero fattura",
    customer: "cliente",
    property: "alloggio",
    total: "totale",
    status: "stato",
    date: "data",
  },
  sort: {
    sortBy: "Ordina per {label}",
    sortedBy: "Ordinato per {label}, {direction}. Cambia l'ordine",
    asc: "crescente",
    desc: "decrescente",
  },
  actions: {
    openPdf: "Apri la fattura come PDF",
    editDraftTitle: "Modifica i dati del cliente e le voci",
    edit: "Modifica",
    previewTitle: "Apri un'anteprima senza validità fiscale",
    preview: "Anteprima",
    sendQuote: "Preventivo",
    sendQuoteTitle: "Invia il preventivo al cliente via email",
    emitTitle: "Rivedi ed emetti la fattura",
    emit: "Emetti",
    syncTitle: "Aggiorna lo stato della fattura",
    sync: "Aggiorna",
    retryTitle: "Riprova con i dati di fatturazione aggiornati",
    retry: "Riprova",
    moreOptions: "Altre opzioni",
    moreOptionsAria: "Altre opzioni fattura",
    editCustomer: "Modifica i dati del cliente",
    deleteReset: "Elimina e reimposta la richiesta",
    voidReissue: "Annulla e riemetti",
  },
  empty: {
    searchTitle: "Nessuna fattura trovata",
    searchText: "Nessun risultato corrisponde alla ricerca e ai filtri attuali.",
    clearFilters: "Cancella i filtri",
    title: "Ancora nessuna fattura",
    text: "Crea una bozza ed emettila quando i dati fiscali e gli addebiti sono pronti.",
    createFirst: "Crea la tua prima fattura",
  },
  errorModal: {
    title: "Errore della fattura",
    hintBefore: "Se l'errore riguarda i tuoi dati di fatturazione (codice fiscale, serie…), correggili in",
    hintSettingsPath: "Impostazioni → Fatturazione",
    hintBetween: "e poi usa",
    hintRetryWord: "Riprova",
    hintGuest: "Se l'errore riguarda i dati dell'ospite, usa",
    hintEditWord: "Modifica i dati del cliente",
    close: "Chiudi",
    retryNow: "Riprova ora",
  },
  editCustomer: {
    title: "Modifica i dati del cliente",
    subtitle: "Correggi i dati e riprova a emettere la fattura",
    name: "Nome / Ragione sociale *",
    taxId: "Codice fiscale / Partita IVA",
    country: "Paese (codice a 2 lettere) *",
    email: "Email *",
    address: "Indirizzo",
    city: "Città",
    zip: "Codice postale",
    hint: "Al salvataggio, l'invio della fattura verrà ritentato automaticamente.",
    cancel: "Annulla",
    saving: "Salvataggio…",
    save: "Salva e riprova",
  },
  deleteConfirm: {
    title: "Elimina fattura",
    body1: "Questo tentativo di fattura verrà eliminato e la",
    bodyStrong: "richiesta dell'ospite verrà reimpostata",
    body2: ", permettendogli di inserire i propri dati e richiedere di nuovo la fattura.",
    irreversible: "Questa azione non può essere annullata.",
    cancel: "Annulla",
    deleting: "Eliminazione…",
    confirm: "Sì, elimina",
  },
  create: {
    titleEdit: "Modifica bozza",
    titleCreate: "Crea fattura",
    subtitleEdit: "Aggiorna il cliente, il contesto e le voci. Non viene emessa.",
    subtitleCreate: "Bozza — nessun numero finché non viene emessa. Nessuna prenotazione richiesta.",
    loading: "Caricamento della bozza…",
    clientLabel: "Cliente *",
    clientHelp: "Seleziona un profilo di fatturazione salvato o creane uno nuovo.",
    newClient: "Nuovo cliente",
    company: "Azienda",
    individual: "Privato",
    change: "Cambia",
    clientSearchPlaceholder: "Cerca per nome, email o documento…",
    incomplete: "Incompleto",
    noClients: "Nessun cliente trovato.",
    createClient: "Crea cliente",
    contextTitle: "Contesto della fattura",
    optional: "Facoltativo",
    contextHelp: "Collega questa fattura per mantenerne la tracciabilità. Puoi lasciare vuoti entrambi i campi.",
    propertyLabel: "Alloggio",
    propertyPlaceholder: "Cerca alloggio…",
    typeToSearchProperties: "Digita per cercare gli alloggi.",
    noProperties: "Nessun alloggio trovato.",
    reservationLabel: "Prenotazione",
    reservationPlaceholder: "Cerca codice, ospite, email…",
    noHolder: "Nessun titolare",
    typeToSearchReservations: "Digita per cercare le prenotazioni.",
    noReservations: "Nessuna prenotazione trovata.",
    contextNotice: "La prenotazione imposta l'alloggio e aggiunge il soggiorno se non è ancora stato fatturato.",
    chargesTitle: "Addebiti e servizi",
    chargesHelp: "Seleziona le voci salvate nel tuo catalogo.",
    addCharge: "Aggiungi addebito o servizio",
    colConcept: "Voce",
    colQty: "Qtà",
    colUnitPrice: "Prezzo unitario",
    colTotal: "Totale",
    docTitle: "Come sarà la fattura",
    docHint: "Queste sono le righe che porterà il PDF. L'alloggio, gli sconti e gli addebiti automatici arrivano dalla prenotazione: qui sopra modifichi solo gli addebiti del tuo catalogo.",
    due: "Da incassare",
    assumed: "Non risultano incassi su questa prenotazione. L'importo viene dato per incassato in base al metodo di pagamento indicato, e il PDF dirà lo stesso.",
    linesEmpty: "Aggiungi una o più voci dal tuo catalogo.",
    total: "Totale",
    cancel: "Annulla",
    saving: "Salvataggio…",
    saveChanges: "Salva le modifiche",
    saveDraft: "Salva bozza",
  },
  contextSummary: {
    property: "Alloggio selezionato",
    empty: "Aggiungi alloggio o prenotazione",
  },
  emit: {
    title: "Emetti fattura",
    subtitle: "Questa azione assegnerà il numero fiscale definitivo.",
    client: "Cliente",
    property: "Alloggio",
    total: "Totale",
    warning: "Una volta emessa, non potrai modificarla direttamente; qualsiasi correzione richiederà un documento rettificativo.",
    cancel: "Annulla",
    emitting: "Emissione…",
    confirm: "Emetti fattura",
  },
  editDraft: {
    title: "Modifica bozza",
    subtitle: "Modifica i dati del cliente e le voci. Non viene emessa.",
    loading: "Caricamento della bozza…",
    individual: "Privato",
    individualSub: "Persona fisica",
    company: "Azienda",
    companySub: "Persona giuridica",
    legalName: "Ragione sociale *",
    fullName: "Nome e cognome *",
    companyNamePlaceholder: "Nome dell'azienda",
    individualNamePlaceholder: "Nome e cognome",
    country: "Paese *",
    docCompany: "Partita IVA (VAT)",
    docIndividual: "Documento d'identità / Passaporto",
    docCompanyPlaceholder: "VAT / Codice fiscale",
    docIndividualPlaceholder: "Documento d'identità o passaporto",
    email: "Email",
    emailOptional: "(facoltativo)",
    lodgingTitle: "Alloggio",
    lodgingName: "Alloggio",
    lodgingNoteBefore: "Preso dalla prenotazione",
    lodgingNoteAfter: ". Per modificare questo importo, modificalo nella prenotazione.",
    chargesTitle: "Addebiti e servizi",
    chargesHelp: "Aggiungi voci salvate senza modificare l'alloggio.",
    addCharge: "Aggiungi addebito o servizio",
    colConcept: "Voce",
    colQty: "Qtà",
    colUnitPrice: "Prezzo unitario",
    colTotal: "Totale",
    linesEmpty: "Nessuna voce aggiuntiva.",
    linesEmptyReserva: "La fattura include solo l'alloggio.",
    total: "Totale",
    cancel: "Annulla",
    saving: "Salvataggio…",
    saveChanges: "Salva le modifiche",
  },
  void: {
    doneTitle: "Fattura annullata",
    doneSubtitle: "Fattura rettificativa emessa correttamente",
    whatHappened: "Cosa è successo?",
    doneCreditNote: "È stata emessa la fattura rettificativa",
    doneListed: "La fattura resta nell'elenco contrassegnata come annullata",
    doneCharges: "Gli addebiti aggiuntivi sono stati liberati",
    doneGuest: "L'ospite può richiedere di nuovo la fattura",
    nextStepsLabel: "Prossimi passi:",
    nextStepsText: "Puoi aggiungere o correggere gli addebiti sulla prenotazione. Poi reinvia il link di fatturazione all'ospite.",
    understood: "Ho capito",
    title: "Annulla e riemetti la fattura",
    introBefore: "Questa azione",
    introStrong: "annullerà la fattura emessa",
    introAfter: "tramite una fattura rettificativa ufficiale.",
    willEmit: "Verrà emessa una fattura rettificativa",
    willList: "La fattura resterà nell'elenco contrassegnata come annullata",
    willFree: "Gli addebiti aggiuntivi verranno liberati",
    willAllowGuest: "L'ospite potrà richiedere di nuovo la fattura",
    reasonLabel: "Motivo dell'annullamento",
    reasonOther: "Altro motivo…",
    reasonPlaceholder: "Spiega perché stai annullando questa fattura",
    warning: "La fattura rettificativa è un documento fiscale ufficiale. Usala solo se hai davvero bisogno di correggere la fattura.",
    cancel: "Annulla",
    emitting: "Emissione della fattura rettificativa…",
    confirm: "Sì, annulla e riemetti",
  },
  statusFilters: {
    all: "Tutte",
    draft: "Bozze",
    sent: "Emesse",
    processing: "In elaborazione",
    error: "Con errori",
    pending: "In sospeso",
    voided: "Annullate",
  },
  voidReasons: {
    wrongTaxData: "Dati fiscali del cliente errati",
    wrongAmount: "Importo o addebiti errati",
    duplicate: "Fattura duplicata",
    cancelledReservation: "Prenotazione annullata",
    reissue: "Annullata per riemetterla con dati o addebiti corretti",
  },
  statusLabels: {
    draft: "Bozza",
    sent: "Emessa",
    processing: "In elaborazione",
    error: "Errore",
    pending: "In sospeso",
    corrected: "Corretta",
    voided: "Annullata",
  },
  client: {
    fallbackName: "Cliente",
    fiscalPending: "Profilo di fatturazione in sospeso",
    fiscalSaved: "Profilo di fatturazione salvato",
  },
  reservation: {
    noCode: "Nessun codice",
    noDates: "Nessuna data",
    noHolder: "Nessun titolare",
    propertyFallback: "Alloggio #{id}",
  },
  emisorFallback: "Emittente #{id}",
  toasts: {
    selectClientComplete: "Seleziona un cliente con un profilo di fatturazione completo.",
    selectReservationOrCharge: "Seleziona una prenotazione o aggiungi almeno un addebito o servizio.",
    saveDraftError: "Non è stato possibile salvare la bozza.",
    createError: "Non è stato possibile creare la fattura.",
    quoteSent: "Preventivo inviato a {email}",
    quoteError: "Non è stato possibile inviare il preventivo.",
    previewError: "Non è stato possibile generare l'anteprima.",
    previewName: "Anteprima",
    emitRejected: "La piattaforma fiscale ha rifiutato l'emissione.",
    emitError: "Non è stato possibile emettere la fattura. Controlla i dati fiscali e riprova.",
    selectClientToContinue: "Seleziona un cliente con un profilo di fatturazione per continuare.",
    loadDraftError: "Non è stato possibile caricare i dati della bozza.",
    nameRequired: "Inserisci il nome del cliente.",
    countryRequired: "Seleziona il paese del cliente.",
    selectCatalogCharge: "Seleziona almeno un addebito o servizio dal catalogo.",
    retryError: "Il nuovo tentativo non è riuscito.",
    saveError: "Impossibile salvare.",
    voidError: "Non è stato possibile annullare la fattura.",
    deleteError: "Impossibile eliminare.",
  },
};
